import React from 'react';

// =====================================================================
// REDE DE SEGURANÇA CONTRA O ECRÃ PRETO
// ---------------------------------------------------------------------
// O <body> do index.html é preto. Quando um erro rebentava dentro de um
// ecrã (o Perfil, por exemplo), o React 19 desmontava a árvore INTEIRA e
// o que sobrava era o fundo preto do body — sem mensagem, sem consola
// visível, sem forma de voltar atrás. No iPhone era ainda pior: não há
// consola à mão para perceber o que aconteceu.
//
// Esta barreira apanha o erro, mostra um ecrã legível com o motivo e dá
// dois caminhos de saída (tentar outra vez / recarregar). O erro fica
// também em window.__ultimoErroGFL para o diagnóstico remoto.
// =====================================================================
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { erro: null, detalhe: null, mostrarDetalhe: false };
  }

  static getDerivedStateFromError(erro) {
    return { erro };
  }

  componentDidCatch(erro, info) {
    const detalhe = `${erro?.stack || erro?.message || erro}\n\n${info?.componentStack || ''}`;
    window.__ultimoErroGFL = { ecra: this.props.ecra || 'app', mensagem: String(erro?.message || erro), detalhe };
    console.error(`Erro no ecrã "${this.props.ecra || 'app'}":`, erro, info);
    this.setState({ detalhe });
  }

  tentarDeNovo = () => {
    this.setState({ erro: null, detalhe: null, mostrarDetalhe: false });
    if (typeof this.props.aoRecuperar === 'function') this.props.aoRecuperar();
  };

  render() {
    if (!this.state.erro) return this.props.children;

    return (
      <div
        style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: '#000', color: '#fff', zIndex: 2147483000,
          display: 'flex', flexDirection: 'column', alignItems: 'center',
          justifyContent: 'center', gap: '14px', padding: '30px',
          textAlign: 'center', boxSizing: 'border-box', overflowY: 'auto',
          WebkitOverflowScrolling: 'touch',
        }}
      >
        <div style={{ fontSize: '38px' }}>⚽</div>
        <h2 style={{ color: '#39FF14', fontSize: '17px', fontWeight: 900, margin: 0 }}>
          ALGO FALHOU NESTE ECRÃ
        </h2>
        <p style={{ color: '#aaa', fontSize: '12px', margin: 0, maxWidth: '300px', lineHeight: 1.5 }}>
          Já apanhámos o erro. Podes tentar outra vez ou voltar ao estádio — não perdes a tua conta.
        </p>

        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', justifyContent: 'center' }}>
          <button
            onClick={this.tentarDeNovo}
            style={{
              background: '#39FF14', color: '#000', border: 'none', borderRadius: '25px',
              padding: '12px 24px', fontWeight: 900, fontSize: '13px', cursor: 'pointer',
            }}
          >
            TENTAR OUTRA VEZ
          </button>
          <button
            onClick={() => window.location.replace(window.location.pathname)}
            style={{
              background: 'transparent', color: '#fff', border: '1px solid #444',
              borderRadius: '25px', padding: '12px 24px', fontWeight: 900, fontSize: '13px',
              cursor: 'pointer',
            }}
          >
            VOLTAR AO ESTÁDIO
          </button>
        </div>

        <button
          onClick={() => this.setState((s) => ({ mostrarDetalhe: !s.mostrarDetalhe }))}
          style={{
            background: 'none', border: 'none', color: '#666', fontSize: '11px',
            textDecoration: 'underline', cursor: 'pointer', marginTop: '4px',
          }}
        >
          {this.state.mostrarDetalhe ? 'esconder detalhes' : 'ver detalhes técnicos'}
        </button>

        {this.state.mostrarDetalhe && (
          <pre
            style={{
              color: '#ff8080', fontSize: '10px', textAlign: 'left', maxWidth: '100%',
              maxHeight: '40vh', overflow: 'auto', WebkitOverflowScrolling: 'touch',
              background: '#111', padding: '12px', borderRadius: '10px',
              whiteSpace: 'pre-wrap', wordBreak: 'break-word', margin: 0,
            }}
          >
            {this.state.detalhe || String(this.state.erro)}
          </pre>
        )}
      </div>
    );
  }
}

export default ErrorBoundary;
